import { render } from "./GoalConfidenceActivity.vue?vue&type=template&id=2e127080"
import script from "./GoalConfidenceActivity.vue?vue&type=script&lang=js"
export * from "./GoalConfidenceActivity.vue?vue&type=script&lang=js"
script.render = render

export default script